/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import gql from 'graphql-tag';
export const GET_WORK_PERMIT_LIST = gql`
  query GetListOfWorkPermit($input: GetCredentialListInput) {
    getListOfWorkPermit(input: $input) {
      totalCount
      totalPages
      currentPage
      pageSize
      data {
        credentialNo
        validTill
        validFrom
        status
        renewalStatus
        employer {
          name
        }
        issuedTo {
          email
          fullName
          firstName
          lastName
          middleName
        }
        application {
          applicantInfo {
            firstName
            fullName
            email
            lastName
          }
        }
      }
    }
  }
`;
